import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_alt",
  "use": "arrow_alt-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"arrow_alt\"><path fill-rule=\"evenodd\" d=\"m5 8 4.995 5 4.995-5H5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol